document.addEventListener("DOMContentLoaded", function() {
    const variantSelect = document.querySelector('[name="id"]'); // Standard-Dropdown für Varianten
    const alkoholgehaltContainers = document.querySelectorAll('.variant-alkoholgehalt');

    if (variantSelect) {
        variantSelect.addEventListener("change", function() {
            const selectedVariantId = this.value;

            alkoholgehaltContainers.forEach(container => {
                if (container.dataset.variantId === selectedVariantId) {
                    container.style.display = "block";
                } else {
                    container.style.display = "none";
                }
            });
        });
    }
});
